"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCarouselSlide = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CarouselSlideMixin = require("../../mixins/components/CarouselSlideMixin");
var _Flex = require("../Flex/Flex");
var StyledCarouselSlide = /*#__PURE__*/(0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "StyledCarouselSlide",
  componentId: "c11n-8-107-0__sc-1p640hm-0"
})(["", ""], _CarouselSlideMixin.CarouselSlideMixin);
exports.StyledCarouselSlide = StyledCarouselSlide;